
import { Component, Prop } from 'vue-property-decorator'
import ButtonMixin from '@/components/common/buttons/button-mixin'

@Component
export default class ButtonContained extends ButtonMixin {
  @Prop({ default: 'button' }) tag!: string
  @Prop({ default: '' }) href!: string
  @Prop({ default: '' }) linkTrackSelector!: string
  @Prop() color!: string
  @Prop() iconNameRight!: string

  private type = 'contained'

  private typeProp: object = {
    class: {
      contained: 'font-bold text-mono-lightest',
      outlined: 'font-bold text-mono-darkest border-3 border-solid',
      text: ''
    },
    style: {
      contained: {},
      outline: {},
      text: {}
    }
  }

  private sizeProp = {
    class: {
      s: 'rounded-8 text-15 leading-3',
      m: 'rounded-9 text-15 leading-3',
      l: 'rounded-12 text-20 leading-3'
    },
    style: {
      s: { height: '40px', padding: '0 17px' },
      m: { height: '52px', padding: '0 58px' },
      l: { height: '64px', padding: '0 50px' }
    }
  }

  private colorProp = {
    class: {
      contained: {
        orange: 'bg-prim-1 hover:bg-prim-1-dark focus:bg-prim-1-dark',
        blue: 'bg-prim-2 hover:bg-prim-2-dark focus:bg-prim-2-dark',
        green: 'bg-prim-3 hover:bg-prim-3-dark focus:bg-prim-3-dark'
      },
      outlined: {
        orange: 'hover:text-prim-1 hover:underline focus:text-prim-1 active:text-mono-more-lighter bg-prim-1-lightest border-prim-1-lightest focus:border-prim-1 active:border-prim-1 active:bg-prim-1',
        blue: 'hover:text-prim-2 hover:underline focus:text-prim-2 active:text-mono-more-lighter bg-prim-2-lightest border-prim-2-lightest focus:border-prim-2 active:border-prim-2 active:bg-prim-2',
        green: 'hover:text-prim-3 hover:underline focus:text-prim-3 active:text-mono-more-lighter bg-prim-3-lightest border-prim-3-lightest focus:border-prim-3 active:border-prim-3 active:bg-prim-3'
      }
    },
    style: {
      orange: {},
      blue: {},
      green: {}
    }
  }
}
